var _rect, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCanceled = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40",
  ref: ref
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  fill: "#DB5C67",
  rx: 20
})), /*#__PURE__*/React.createElement("mask", {
  id: "canceled_svg__a",
  width: 24,
  height: 24,
  x: 8,
  y: 8,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M8 8h24v24H8z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#canceled_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m20 21.4-4.9 4.9a.949.949 0 0 1-.7.275.948.948 0 0 1-.7-.275.948.948 0 0 1-.274-.7c0-.284.091-.517.275-.7l4.9-4.9-4.9-4.9a.948.948 0 0 1-.275-.7c0-.284.091-.517.275-.7a.948.948 0 0 1 .7-.275c.283 0 .516.091.7.275l4.9 4.9 4.9-4.9a.948.948 0 0 1 .7-.275c.283 0 .516.091.7.275a.948.948 0 0 1 .275.7.948.948 0 0 1-.275.7L21.4 20l4.9 4.9a.948.948 0 0 1 .275.7.948.948 0 0 1-.275.7.949.949 0 0 1-.7.275.948.948 0 0 1-.7-.275L20 21.4Z"
}))));
SvgCanceled.viewBox = '0 0 40 40';
const ForwardRef = /*#__PURE__*/forwardRef(SvgCanceled);
export default ForwardRef;